import React from 'react';
import '../App.js';
import { useNavigate, useParams } from 'react-router-dom';
import useAuth from '../hooks/useAuth.js';
import { useEffect } from 'react';
import useAxiosPrivate from '../hooks/useAxiosPrivate';

function CreateComment() {       
    const [content, setContent] = React.useState('');
    const [author, setAuthor] = React.useState('');
    const [postTitle, setPostTitle] = React.useState('');

    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const { auth } = useAuth();
    const { postId } = useParams(); // get postId

    // set errors
    const [errors, setErrors] = React.useState({});
    
    // max. character for a single comment
    const maxCharacters = 5000;

    const charactersLeft = Math.max(0, maxCharacters - content.length);

    useEffect(() => {
        const getUserData = async () => {            
            try {
                // setting data
                setAuthor(auth.username);
            } catch (err) {
                console.log(err);
            }
        }
        
        const getPostTitle = async () => {
            try {
                const res = await axiosPrivate.get(`api/Post/${postId}`);
                setPostTitle(res.data.title);
            } catch (err) {
                console.log('Error fetching post:', err);
            }
        };
        
        getUserData();
        
        if (postId) {
            getPostTitle();
        } else {
            setErrors({ server: 'No post ID provided.' });
            setTimeout(() => {
                navigate('/blog');
            }, 2000);
        }
    }, [auth.username, postId, navigate, axiosPrivate]);

    const handleSubmit = async (e) => {
        // prevent default behavior of the form (prevent reloading)
        e.preventDefault();
        setErrors({});

        if (!validate()) {
            return;
        }

        // check postId
        if (!postId) {
            setErrors({ server: 'Post Id is missing.' });
            return;
        }

        const data = {
            content: content,
            creationDate: new Date().toISOString(),
            author: author
        };
    
        try {
            const CREATECOMMENT_URL = `api/Comment/post/${postId}`;
            
            const res = await axiosPrivate.post(
                CREATECOMMENT_URL,
                data,
                {
                    headers: { 'Content-Type': 'application/json' }
                }
            );

            console.log('Comment created successfully!');
            // navigate back to the post page
            navigate(`/blog/${postId}`);
                
        } catch (err) {
            console.log('Error creating a comment: ', err);

            if (err.response?.status === 401) {
                console.log('Unauthorized - token might have expired.');
                navigate('/login');
            } else if (err.response?.status === 403) {
                console.log('Forbidden - insufficient permissions.');
                navigate('/unauthorized');
            } else if (err.response?.status === 404) {
                setErrors({ server: 'Post not found.' });
            } else {
                setErrors({ server: 'Failed to create comment. Please try again.' });
            }
        }
    }

    const validate = () => {
        var errors = {};

        // content validation
        errors.content = content !== '' ? '' : 'Type in the content of the comment!';
        errors.author = author !== '' ? '' : 'Author is required!';

        setErrors(errors);

        return Object.values(errors).every(item => item === '');
    }

    const handleCancel = () => {
        if (postId) {
            navigate(`/blog/${postId}`);
        } else {
            navigate('/blog');
        }
    };

    // show error
    if (!postId) {
        return (
            <div className='comment-create'>
                <h1 className='mt-5'>Your comment</h1>
                <div className='alert alert-warning'>
                    No post selected. Redirecting to blog...
                </div>
            </div>
        );
    }

    return (
        <div className='comment-create'>
            <h1 className='mt-5'>Your comment</h1>
            {postTitle && <p className='text-muted'>Replying to: <strong>{ postTitle }</strong></p>}
            <form onSubmit={ handleSubmit }>
                <div className='comment-form'>
                    {errors.server && <div className='alert alert-danger'>{ errors.server }</div>}
                    <label className='comment-label'>
                        Text:
                    </label>
                    <textarea 
                        className='form-control mb-2 ms-2' 
                        rows='10' 
                        placeholder='Your text...' 
                        value={ content }
                        onChange={(e) => {
                            setContent(e.target.value);
                        }}
                        maxLength={ maxCharacters } 
                    />
                    <div className='character-count'>
                        <p>Characters left: { charactersLeft }</p>
                    </div>
                    { errors.content && <div className='error-text'>{ errors.content }</div> }
                </div>
                <button type='submit' className='btn btn-outline-dark me-2'>Reply</button>
                <button 
                    type='button' 
                    className='btn btn-dark' 
                    onClick={ handleCancel }
                >
                    Cancel
                </button>
            </form>
        </div>
    )
};

export default CreateComment;